import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useConfig } from '#/hooks';
import { Path } from '#/service/routes';
import { useAuthentication } from '#/store/auth';

let wasOnOtherPage = false;

export const useUnauthenticatedHomePage = () => {
  const { isLoggedIn, isInitialised, wasLoggedIn } = useAuthentication();
  const { featureConfig, pages } = useConfig();
  const { pathname } = useLocation();

  const isConfigured =
    !!featureConfig?.unauthenticatedHomepage?.enabled &&
    !!pages.UNAUTHENTICATED_HOMEPAGE;

  useEffect(() => {
    if ([Path.Home, Path.Registration].includes(pathname)) {
      return;
    }

    wasOnOtherPage = true;
  }, [pathname]);

  const isLoading = isConfigured && !isInitialised && pathname === Path.Home;
  const shouldShow =
    isConfigured &&
    isInitialised &&
    !isLoggedIn &&
    !wasLoggedIn &&
    !wasOnOtherPage;
  const pageId = pages.UNAUTHENTICATED_HOMEPAGE;
  const isUnauthenticatedHomePage = (pageId: string) =>
    shouldShow && pageId === pages.UNAUTHENTICATED_HOMEPAGE;

  return {
    isLoading,
    shouldShow,
    pageId,
    isUnauthenticatedHomePage,
  };
};
